import { Injectable } from '@angular/core';
import { Observable, empty } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import { ILanguages, BaseResponse } from '../models';
import { catchError, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class LanguageTranslationService {

  constructor(private httpClient: HttpClient) { }
  //#region language translation Api call
  public getLanguageLabel(body): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.LANGUAGE_TRANSLATION.GET_LANGUAGE_TEXT}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getLanguages(): Observable<Array<ILanguages>> {
    const endPoint = `${ConfigService.APIs.endPoints.LANGUAGE_TRANSLATION.GET_LANGUAGES}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion
  cotrolTextList: any = [];
  languageList: any;
  getLanguageTranslationList(controlNames, componentName) {

    const languageCode = localStorage.getItem('aap_language')
    this.languageList = JSON.parse(localStorage.getItem("aap_LanguageText"));
    if (this.languageList) {
      const datalist = this.languageList.filter(r => r.componentName === componentName && r.languageCode === languageCode);
      var myobj = {};
      var obj = {};
      for (var j = 0; j < controlNames.length; j++) {
        for (var i = 0; i < datalist.length; i++) {
          if (controlNames[j].controlName == datalist[i].controlName) {

            obj[datalist[i].controlName] = datalist[i].controlText;
            Object.assign(myobj, obj);
            break;
          }
        }
      }
      this.cotrolTextList.push(myobj);
    }
    return this.cotrolTextList;
  }

}
